export const EVENT_SESSION_TYPE_OPTIONS = [
  { value: 'main_event', label: 'Main Event' },
  { value: 'practice_session', label: 'Practice Session' },
];
export const isValidEventSessionType = (value) => EVENT_SESSION_TYPE_OPTIONS.some(option => option.value === value);
export const getEventSessionTypeLabel = (value) => value === 'practice_session' ? 'Practice Session' : 'Main Event';
